export enum FeatureFlagName {
  passwordless_magic_link_enabled = 'passwordless_magic_link_enabled',
}

export interface FeatureFlag {
  name: FeatureFlagName;
  active: boolean;
}
